// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown_entry-component-search-box-container__ID673{
   position: relative;
   z-index: 0;
   /* margin-top: 26vw; */
   width: 18vw;
   height: 3vw;
   background-color: rgba(255, 255, 255, 0.37);
   /* margin-left: 19.5vw; */
   border-radius: 100vw;
   border: 1px solid #e1e1e1;
   padding: 0.1px;
   font-family: dm-sans-light;
   /* box-sizing: border-box; */
}


.Dropdown_entry-component-search-box__V3zYC{
   width: 18vw;
   height: 3vw;
   background-color: white;
   border-radius: 100vw;
   align-self: center;
   align-items: center;
   /* margin: 1vw auto auto; */
   cursor: pointer;
   box-sizing: border-box;
   padding-left: 2vw;
   padding-right: 2vw;
   display: flex;
}


.Dropdown_plc-text__0cMrw{
   font-size: 1.2vw;
   font-family: dm-sans-light;
}


.Dropdown_entry-dropdown-container__L3cps{
   position: absolute;
   z-index: 5;
   background: white;
   width: 20vw;
   height: max-content;
   border-radius: 2vw;
   /* margin-left: 1vw; */
   box-sizing: border-box;
   margin-top: 0.15vw;
   overflow: hidden;
   border: 1px solid #e1e1e1;
}


.Dropdown_entry-dropdown-options__Ty-db{
   display: flex;
   height: 2.5vw;
   align-items: center;
   padding-left: 2vw;
   margin: 0;
   margin-top: 0;
   cursor: pointer;
}


.Dropdown_entry-dropdown-options__Ty-db:hover{
   background-color: #f5715a;
   color: white;
}




@media(max-width: 768px){
   .Dropdown_entry-component-search-box-container__ID673{
       position: absolute;
       /* margin-top: 60vw; */
       width: 84vw;
       z-index: 2;
       height: 12vw;
       background-color: rgba(255, 255, 255, 0.37);
       margin-left: 8vw;
       border-radius: 2vw;
   }


   .Dropdown_entry-component-search-box__V3zYC{
       width: 80vw;
       height: 10vw;
       background-color: white;
       border-radius: 100vw;
       /* align-self: center; */
       margin-top: 1vw;
       margin-left: 2vw;
   }


   .Dropdown_plc-text__0cMrw{
       font-size: 4vw;
   }


   .Dropdown_entry-dropdown-container__L3cps{
       position: absolute;
       background: white;
       width: 82vw;
       height: max-content;
       border-radius: 4vw;
       margin-left: 1vw;
       box-sizing: border-box;
       margin-top: 1.5vw;
       overflow: hidden;
   }
  
   .Dropdown_entry-dropdown-options__Ty-db{
       display: flex;
       height: 7vw;
       align-items: center;
       padding-left: 3vw;
       margin: 0;
       margin-top: 0;
   }
}

`, "",{"version":3,"sources":["webpack://./src/Global/customDropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;GAClB,UAAU;GACV,sBAAsB;GACtB,WAAW;GACX,WAAW;GACX,2CAA2C;GAC3C,yBAAyB;GACzB,oBAAoB;GACpB,yBAAyB;GACzB,cAAc;GACd,0BAA0B;GAC1B,4BAA4B;AAC/B;;;AAGA;GACG,WAAW;GACX,WAAW;GACX,uBAAuB;GACvB,oBAAoB;GACpB,kBAAkB;GAClB,mBAAmB;GACnB,2BAA2B;GAC3B,eAAe;GACf,sBAAsB;GACtB,iBAAiB;GACjB,kBAAkB;GAClB,aAAa;AAChB;;;AAGA;GACG,gBAAgB;GAChB,0BAA0B;AAC7B;;;AAGA;GACG,kBAAkB;GAClB,UAAU;GACV,iBAAiB;GACjB,WAAW;GACX,mBAAmB;GACnB,kBAAkB;GAClB,sBAAsB;GACtB,sBAAsB;GACtB,kBAAkB;GAClB,gBAAgB;GAChB,yBAAyB;AAC5B;;;AAGA;GACG,aAAa;GACb,aAAa;GACb,mBAAmB;GACnB,iBAAiB;GACjB,SAAS;GACT,aAAa;GACb,eAAe;AAClB;;;AAGA;GACG,yBAAyB;GACzB,YAAY;AACf;;;;;AAKA;GACG;OACI,kBAAkB;OAClB,sBAAsB;OACtB,WAAW;OACX,UAAU;OACV,YAAY;OACZ,2CAA2C;OAC3C,gBAAgB;OAChB,kBAAkB;GACtB;;;GAGA;OACI,WAAW;OACX,YAAY;OACZ,uBAAuB;OACvB,oBAAoB;OACpB,wBAAwB;OACxB,eAAe;OACf,gBAAgB;GACpB;;;GAGA;OACI,cAAc;GAClB;;;GAGA;OACI,kBAAkB;OAClB,iBAAiB;OACjB,WAAW;OACX,mBAAmB;OACnB,kBAAkB;OAClB,gBAAgB;OAChB,sBAAsB;OACtB,iBAAiB;OACjB,gBAAgB;GACpB;;GAEA;OACI,aAAa;OACb,WAAW;OACX,mBAAmB;OACnB,iBAAiB;OACjB,SAAS;OACT,aAAa;GACjB;AACH","sourcesContent":[".entry-component-search-box-container{\n   position: relative;\n   z-index: 0;\n   /* margin-top: 26vw; */\n   width: 18vw;\n   height: 3vw;\n   background-color: rgba(255, 255, 255, 0.37);\n   /* margin-left: 19.5vw; */\n   border-radius: 100vw;\n   border: 1px solid #e1e1e1;\n   padding: 0.1px;\n   font-family: dm-sans-light;\n   /* box-sizing: border-box; */\n}\n\n\n.entry-component-search-box{\n   width: 18vw;\n   height: 3vw;\n   background-color: white;\n   border-radius: 100vw;\n   align-self: center;\n   align-items: center;\n   /* margin: 1vw auto auto; */\n   cursor: pointer;\n   box-sizing: border-box;\n   padding-left: 2vw;\n   padding-right: 2vw;\n   display: flex;\n}\n\n\n.plc-text{\n   font-size: 1.2vw;\n   font-family: dm-sans-light;\n}\n\n\n.entry-dropdown-container{\n   position: absolute;\n   z-index: 5;\n   background: white;\n   width: 20vw;\n   height: max-content;\n   border-radius: 2vw;\n   /* margin-left: 1vw; */\n   box-sizing: border-box;\n   margin-top: 0.15vw;\n   overflow: hidden;\n   border: 1px solid #e1e1e1;\n}\n\n\n.entry-dropdown-options{\n   display: flex;\n   height: 2.5vw;\n   align-items: center;\n   padding-left: 2vw;\n   margin: 0;\n   margin-top: 0;\n   cursor: pointer;\n}\n\n\n.entry-dropdown-options:hover{\n   background-color: #f5715a;\n   color: white;\n}\n\n\n\n\n@media(max-width: 768px){\n   .entry-component-search-box-container{\n       position: absolute;\n       /* margin-top: 60vw; */\n       width: 84vw;\n       z-index: 2;\n       height: 12vw;\n       background-color: rgba(255, 255, 255, 0.37);\n       margin-left: 8vw;\n       border-radius: 2vw;\n   }\n\n\n   .entry-component-search-box{\n       width: 80vw;\n       height: 10vw;\n       background-color: white;\n       border-radius: 100vw;\n       /* align-self: center; */\n       margin-top: 1vw;\n       margin-left: 2vw;\n   }\n\n\n   .plc-text{\n       font-size: 4vw;\n   }\n\n\n   .entry-dropdown-container{\n       position: absolute;\n       background: white;\n       width: 82vw;\n       height: max-content;\n       border-radius: 4vw;\n       margin-left: 1vw;\n       box-sizing: border-box;\n       margin-top: 1.5vw;\n       overflow: hidden;\n   }\n  \n   .entry-dropdown-options{\n       display: flex;\n       height: 7vw;\n       align-items: center;\n       padding-left: 3vw;\n       margin: 0;\n       margin-top: 0;\n   }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component-search-box-container": `Dropdown_entry-component-search-box-container__ID673`,
	"entry-component-search-box": `Dropdown_entry-component-search-box__V3zYC`,
	"plc-text": `Dropdown_plc-text__0cMrw`,
	"entry-dropdown-container": `Dropdown_entry-dropdown-container__L3cps`,
	"entry-dropdown-options": `Dropdown_entry-dropdown-options__Ty-db`
};
export default ___CSS_LOADER_EXPORT___;
